import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "index",
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: {
      title: 'product',
      breadcrumbRoot: true
    }
  },
  {
    path: '/lsqLB',
    name: 'lsqLB',
    component: () => import('../views/lsqLB.vue'),
    meta: {
      title: 'lsqLB',
      breadcrumbParent: 'login'
    }
  },
  {
    path: '/DSClsq',
    name: 'DSClsq',
    component: () => import('../views/DSClsq.vue'),
    meta: {
      title: 'DSClsq',
      breadcrumbParent: 'lsqLB'
    }
  },
  {
    path: '/D4Clsq',
    name: 'D4Clsq',
    component: () => import('../views/D4Clsq.vue'),
    meta: {
      title: 'D4Clsq',
      breadcrumbParent: 'DSClsq'
    }
  },
  {
    path: "/index",
    name: "index",
    meta: { title: 'HOME' },
    component: () => import("../views/index.vue")
  },
  {
    path: "/honor",
    name: "honor",
    meta: { title: 'HOME' },
    component: () => import("../views/honor.vue")
  },
  {
    path: "/shzr",
    name: "shzr",
    meta: { title: 'HOME' },
    component: () => import("../views/shzr.vue")
  },
  {
    path: "/cjwt",
    name: "cjwt",
    meta: { title: 'HOME' },
    component: () => import("../views/cjwt.vue")
  },
  {
    path: "/adminLogin",
    name: "adminLogin",
    component: () => import("../views/admin/adminLogin.vue")
  },
  {
    path: "/bhkc",
    name: "bhkc",
    component: () => import("../views/admin/bhkc.vue")
  },
  {
    path: "/jytk",
    name: "jytk",
    component: () => import("../views/jytk.vue")
  },
  {
    path: "/szkb",
    name: "szkb",
    component: () => import("../views/admin/szkb.vue")
  },
   {
    path: "/bdkc",
    name: "bdkc",
    component: () => import("../views/admin/bdkc.vue")
  },
  {
    path: "/myorder",
    name: "myorder",
    component: () => import("../views/admin/myorder.vue")
  },
  {
    path: "/scexcel",
    name: "scexcel",
    component: () => import("../views/SBexcel/scexcel.vue")
  },
  {
    path: "/TGpgd",
    name: "TGpgd",
    component: () => import("../views/SBexcel/TGpgd.vue")
  },
  {
    path: "/GBT",
    name: "GBT",
    component: () => import("../views/SBexcel/GBT.vue")
  },
  {
    path: "/NBpgd",
    name: "NBpgd",
    component: () => import("../views/SBexcel/NBpgd.vue")
  },
  {
    path: "/myFastener",
    name: "myFastener",
    component: () => import("../views/myFastener.vue")
  },
  {
    path: "/DDZT",
    name: "DDZT",
    component: () => import("../views/DDZT.vue")
  },
  {
    path: "/DDXQ",
    name: "DDXQ",
    component: () => import("../views/DDXQ.vue")
  },
    {
    path: "/ysstk",
    name: "ysstk",
    component: () => import("../views/ysstk.vue")
  },
  {
    path: "/guest",
    name: "guest",
    component: () => import("../views/guestbook.vue")
  },
  {
    path: "/search",
    name: "search",
    component: () => import("../views/search.vue")
  },
  {
    path: "/M_T",
    name: "M_T",
    component: () => import("../views/M_T.vue")
  },
  {
    path: "/sider",
    name: "sider",
    component: () => import("../components/sdier.vue")
  },
  {
    path: "/sectors",
    name: "sectors",
    component: () => import("../views/sectors.vue")
  },
  {
    path: "/vim",
    name: "vim",
    component: () => import("../views/vim.vue")
  }, {
    path: "/ksbj",
    name: "ksbj",
    component: () => import("../views/ksbj.vue")
  }, {
    path: "/CompanyProfile",
    name: "CompanyProfile",
    component: () => import("../views/CompanyProfile.vue")
  }, {
    path: "/contactus",
    name: "contactus",
    component: () => import("../views/contactus.vue")
  }
];

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = "Hanglong Fastener";
  next();
});

export default router;
